import { render, staticRenderFns } from "./CreationContent2.vue?vue&type=template&id=19c57442&scoped=true"
import script from "./CreationContent2.vue?vue&type=script&lang=js"
export * from "./CreationContent2.vue?vue&type=script&lang=js"
import style0 from "./CreationContent2.vue?vue&type=style&index=0&id=19c57442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c57442",
  null
  
)

export default component.exports